const JUSTIFICATION = [
  {
    name: 'Alto risco',
    description:
      'O RIPD foi gerado visando descrever e gerir os processos de tratamento de dados pessoais que podem gerar altos riscos às liberdades civis e aos direitos fundamentais, bem como medidas, salvaguardas e mecanismos de mitigação de risco, nos termos do arts. 5º, inciso XVII e 6º, inciso X, da LGPD.',
  },
  {
    name: 'Legítimo Interesse',
    description:
      'A ANPD (Autoridade Nacional de Proteção de Dados) solicitou ao controlador a emissão do RIPD, em decorrência da presença do fundamento do Legítimo Interesse no presente processo, observados os segredos comercial e industrial, nos termos do art. 10, § 3º, da LGPD.',
  },
  {
    name: 'Poder Público',
    description:
      'A ANPD (Autoridade Nacional de Proteção de Dados) solicitou aos agentes do Poder Público a publicação do RIPD, nos termos do art. 32 da LGPD.',
  },
  {
    name: 'Dados pessoais sensíveis',
    description:
      'A ANPD (Autoridade Nacional de Proteção de Dados) solicitou ao controlador a emissão do RIPD, em decorrência da presença de dados pessoais sensíveis neste processo, nos termos do art. 38, da LGPD.',
  },
  {
    name: 'Princípio da segurança e da prevenção',
    description:
      'O controlador gerou o presente RIPD, visando o cumprimento dos princípios da segurança e da prevenção, nos termos do art. 6º, VII e VIII, da LGPD, a fim de implementar programa de governança em privacidade que, entre outros itens, deve estabelecer políticas e salvaguardas adequadas com base em processo de avaliação sistemática de impactos e riscos à privacidade, conforme determinação do art. 50, § 2º, I, d,d a LGPD.',
  },
  {
    name: 'Operações de tratamento efetuadas para fins exclusivos de segurança pública, defesa nacional, segurança do Estado ou atividades de investigação e repressão de infrações penais',
    description:
      'A ANPD (Autoridade Nacional de Proteção de Dados) solicitou aos responsáveis por operações de tratamento para fins de segurança pública, defesa nacional, segurança do Estado ou atividades de investigação e repressão de infrações penais, a emissão do RIPD, nos termos do art. 4º,  § 3º, da LGPD.',
  },
]

const JUSTIFICATION_LABEL = {
  'Alto risco':
    'O RIPD foi gerado visando descrever e gerir os processos de tratamento de dados pessoais que podem gerar altos riscos às liberdades civis e aos direitos fundamentais, bem como medidas, salvaguardas e mecanismos de mitigação de risco, nos termos do arts. 5º, inciso XVII e 6º, inciso X, da LGPD.',
  'Legítimo Interesse':
    'A ANPD (Autoridade Nacional de Proteção de Dados) solicitou ao controlador a emissão do RIPD, em decorrência da presença do fundamento do Legítimo Interesse no presente processo, observados os segredos comercial e industrial, nos termos do art. 10, § 3º, da LGPD.',

  'Poder Público':
    'A ANPD (Autoridade Nacional de Proteção de Dados) solicitou aos agentes do Poder Público a publicação do RIPD, nos termos do art. 32 da LGPD.',

  'Dados pessoais sensíveis':
    'A ANPD (Autoridade Nacional de Proteção de Dados) solicitou ao controlador a emissão do RIPD, em decorrência da presença de dados pessoais sensíveis neste processo, nos termos do art. 38, da LGPD.',
  'Princípio da segurança e da prevenção':
    'O controlador gerou o presente RIPD, visando o cumprimento dos princípios da segurança e da prevenção, nos termos do art. 6º, VII e VIII, da LGPD, a fim de implementar programa de governança em privacidade que, entre outros itens, deve estabelecer políticas e salvaguardas adequadas com base em processo de avaliação sistemática de impactos e riscos à privacidade, conforme determinação do art. 50, § 2º, I, d,d a LGPD.',
  'Operações de tratamento efetuadas para fins exclusivos de segurança pública, defesa nacional, segurança do Estado ou atividades de investigação e repressão de infrações penais':
    'A ANPD (Autoridade Nacional de Proteção de Dados) solicitou aos responsáveis por operações de tratamento para fins de segurança pública, defesa nacional, segurança do Estado ou atividades de investigação e repressão de infrações penais, a emissão do RIPD, nos termos do art. 4º,  § 3º, da LGPD.',
}

const RISK = [
  { id: 3, name: 'Alto' },
  { id: 4, name: 'Severo' },
  { id: 5, name: 'Alto e Severo' },
]

const DESCRIPTION_RIPD = {
  title: 'Relatório de Impacto à Proteção de Dados Pessoais (RIPD)',
  content:
    'Em geral, o Relatório de Impacto à Proteção de Dados Pessoais (RIPD) é ' +
    'um documento que estabelece a gestão de riscos da sua organização. Ele ' +
    'contém a descrição detalhada dos seus processos de tratamento de dados ' +
    'pessoais que possuem risco alto ou severo e quais medidas são adotadas ' +
    'para mitigação dos riscos. Pode haver exceções, como:',
  options: [
    'Hipótese de Legítimo Interesse;',
    'Outras obrigações legais;',
    'Segurança Pública;',
    'Entre outros.',
  ],
}

const DESCRIPTION_ROPA = {
  title: 'Registro das Atividades de Tratamento (RoPA)',
  content:
    'O Registro das Atividades de Tratamento (traduzido da sigla em inglês, ' +
    'Record of Processing Activities, RoPA, é um documento essencial do ' +
    'Regulamento Geral de Proteção de Dados (GDPR) da União Europeia. É ' +
    'um documento que detalha todas as atividades de processamento de dados ' +
    'pessoais realizadas por uma organização. O RoPA inclui informações ' +
    'sobre a finalidade do processamento, as categorias de dados pessoais ' +
    'envolvidos, os enquadramentos legais, os destinatários dos dados, os ' +
    'prazos de retenção dos dados e as medidas de segurança implementadas, ' +
    'dentre outras informações. O RoPA desempenha um papel fundamental na ' +
    'conformidade com o GDPR, ajudando as organizações a demonstrar ' +
    'transparência e responsabilidade no tratamento de dados pessoais.',
  options: [],
}

const DESCRIPTION_RMC = {
  title: 'Relatório de RMC’s',
  content:
    'No contexto da LGPD, a melhoria contínua implica que as organizações devem sempre buscar aprimorar seus processos, políticas e medidas de segurança para garantir conformidade com a lei e proteção adequada dos dados pessoais. Isso envolve revisões regulares de políticas, implementação de medidas de segurança adicionais, atualização de procedimentos, treinamentos periódicos e adoção de tecnologias avançadas. ',
  options: [],
}

const DESCRIPTION_ACCOUNTABILITY = {
  title: 'Relatório de Prestação de Contas',
  content:
    'O relatório de declaração de prestação de contas tem como objetivo demonstrar que o agente adotou medidas eficazes e capazes de comprovar a observância e o cumprimento das normas de proteção de dados pessoais. Ele estabelece um paralelo entre as funcionalidades da plataforma e os requisitos da Lei de Proteção de Dados.',
  options: [],
}

const DESCRIPTION_MANAGEMENT = {
  title: 'Relatório Gerencial',
  content:
    'O relatório gerencial é um resumo de informações-chave que fornece uma visão geral do desempenho da organização, auxiliando a alta administração na tomada de decisões estratégicas e operacionais.',
  options: [],
}

const DESCRIPTION_CONTROL = {
  title: 'Relatório de Medidas de Segurança',
  content:
    'O relatório de medidas de segurança avalia se a organização cumpre regulamentações e políticas estabelecidas, identificando áreas de risco e oportunidades de melhoria. Essencial para garantir transparência e conformidade legal. Ele é gerado com base nos questionários respondidos pela organização e nas medidas de segurança que passarão a ser adotados após a realização do plano de ação.',
  options: [],
}

const DESCRIPTION_FRAGILITY = {
  title: 'Relatório de Ameaças',
  content:
    'Este relatório proporciona uma visão abrangente das ameaças presentes na organização, detalhando suas medidas de segurança e os locais em que podem ocorrer.',
  options: [],
}

const DESCRIPTION_TRAINING = {
  title: 'Relatório de Treinamentos',
  content:
    'O relatório de treinamento é um documento sucinto que permite acompanhar a evolução da conscientização dos colaboradores da organização. Ele é uma ferramenta valiosa para identificar bons e maus resultados.',
}

const DESCRIPTION_LIA = {
  title: 'Relatório de Legítimo Interesse',
  content:
    'Um relatório de legítimo interesse é um documento que descreve detalhadamente as razões pelas quais uma organização considera que o processamento de dados pessoais é justificado com base no princípio do legítimo interesse.',
}

const DESCRIPTION_CONSENT = {
  title: 'Relatório de Consentimentos',
  content:
    'O relatório de consentimento é um documento que formaliza a autorização ou o acordo de uma pessoa para participar em uma atividade, projeto ou processo, especialmente em contextos onde a privacidade, a segurança ou a ética são preocupações importantes.',
}

const DESCRIPTION_ACCEPTANCE = {
  title: 'Relatório de Aceites',
  content:
    'O relatório de aceites é um documento que registra formalmente a autorização ou concordância de uma pessoa em relação a políticas e termos estabelecidos pela empresa. É amplamente utilizado por organizações que precisam validar a adesão de colaboradores a normas internas, como, por exemplo, a política de mesa limpa.',
}

const DESCRIPTION_AUDIT = {
  title: 'Relatório de Auditoria',
  content:
    'O relatório de auditoria é essencial para identificar quais processos foram atualizados e quais estão desatualizados durante a auditoria.',
}

const DESCRIPTION_PARTNER = {
  title: 'Relatório de Fornecedores',
  content:
    'O Relatório de Fornecedores oferece uma visão detalhada sobre a conformidade e gestão de riscos dos fornecedores, incluindo informações sobre questionários e níveis de conformidade, facilitando a tomada de decisões para garantir a proteção de dados e o cumprimento das normativas.',
}
const DESCRIPTION_KANBAN_TASKS = {
  title: 'Relatório de Atividades',
  content:
    'Exporte os dados das atividades cadastradas na plataforma. Escolha entre relatório completo, agrupado por departamento, por usuário responsável ou personalize os filtros para obter exatamente os dados que precisa.',
}

const DESCRIPTION_INCIDENT = {
  title: 'Relatório de Incidentes',
  content:
    'Organize e mantenha um histórico completo de incidentes de proteção de dados, com informações essenciais para avaliação de riscos, resposta a autoridades reguladores e melhoria contínua da governança',
}

const DESCRIPTION_COOKIES_CONSENTS = {
  title: 'Relatório de Consentimento de Cookies',
  content:
    'O relatório de cookies é essencial para garantir transparência e conformidade legal, permitindo que empresas acompanhem consentimentos, recusas e preferências dos usuários.',
}
const DESCRIPTION_COOKIES_TAGS = {
  title: 'Relatório de Tags de Cookies',
  content:
    'O Relatório de Tags de Cookies é essencial para garantir transparência e conformidade legal, permitindo que empresas acompanhem as tags utilizadas em seus sites, bem como sua classificação.',
}

const DESCRIPTION_PRIVACY_BY_DESIGN = {
  title: 'Relatório Privacy By Design',
  content:
    'Gere um relatório consolidado dos projetos de Privacy By Design da sua organização. Filtre por projeto específico, departamento ou inclua todos os projetos.',
}

const DESCRIPTION_PHISHING_CAMPAIGN = {
  title: 'Relatório de Phishing',
  content:
    'Gere um relatório consolidado das campanhas de simulação de phishing da sua organização. Filtre por campanha específica ou inclua todas as campanhas.',
}

const DESCRIPTION = {
  acceptance: DESCRIPTION_ACCEPTANCE,
  accountability: DESCRIPTION_ACCOUNTABILITY,
  audit: DESCRIPTION_AUDIT,
  consent: DESCRIPTION_CONSENT,
  control: DESCRIPTION_CONTROL,
  cookiesConsents: DESCRIPTION_COOKIES_CONSENTS,
  cookiesTags: DESCRIPTION_COOKIES_TAGS,
  fragility: DESCRIPTION_FRAGILITY,
  incident: DESCRIPTION_INCIDENT,
  lia: DESCRIPTION_LIA,
  management: DESCRIPTION_MANAGEMENT,
  partner: DESCRIPTION_PARTNER,
  phishing_campaign: DESCRIPTION_PHISHING_CAMPAIGN,
  privacyByDesign: DESCRIPTION_PRIVACY_BY_DESIGN,
  ripd: DESCRIPTION_RIPD,
  rmc: DESCRIPTION_RMC,
  ropa: DESCRIPTION_ROPA,
  training: DESCRIPTION_TRAINING,
  kanbanTasks: DESCRIPTION_KANBAN_TASKS,
}

const CHARACTER_LIMIT = 500

const KIND = {
  ACCEPTANCE: 'acceptance',
  ROPA: 'ropa',
  COMPLIANCE: 'compliance',
  RIPD: 'ripd',
  FRAGILITY: 'fragility',
  TRAINING: 'training',
  LIA: 'lia',
  AUDIT: 'audit',
  PARTNER: 'partner',
  INCIDENT: 'incident',
}

const REPORT_CONSENT_LABELS = {
  reportByReceipt: 'Recibo de Consentimento',
  reportByPeople: 'Relatório de Consentimentos (Por pessoa)',
  reportByForm: 'Relatório de Consentimentos (Por formulário)',
  reportComplete: 'Relatório de Consentimentos (Completo)',
  reportByLegalBasis: 'Relatório de Consentimentos (Por base legal)',
}

const TYPES_CONSENTS = {
  RECEIPT_FORM: 'reportByForm',
  RECEIPT_CONSENT: 'reportByReceipt',
  RECEIPT_PERSONAL: 'reportByPeople',
  RECEIPT_LEGAL_BASIS: 'reportByLegalBasis',
  RECEIPT_COMPLETE: 'reportComplete',
}

const REPORT_TYPES = {
  ALL_PARTNERS: 'reportByAllPartners',
  SINGLE_PARTNER: 'reportByPartner',
  ALL_ASSESSMENTS: 'reportByAllAssessments',
  SINGLE_ASSESSMENT: 'reportByAssessment',
}

const KANBAN_TASKS_FILTER_ALL = 'all'

const KANBAN_TASKS_PRIORITIES = [
  { value: 'high', label: 'Alta' },
  { value: 'medium', label: 'Média' },
  { value: 'low', label: 'Baixa' },
  { value: 'severe', label: 'Severa' },
]

const KANBAN_TASKS_ACTIVITY_TYPES = [
  { value: 'cross_board', label: 'Atividades do Encarregado (DPO)' },
  { value: 'normal', label: 'Atividades de Usuários da Organização' },
  { value: 'automatic', label: 'Automáticas' },
  { value: 'unlinked_tasks', label: 'Desvinculadas' },
  { value: 'source_removed', label: 'Origem removida' },
]

const KANBAN_TASKS_EMPTY_FILTERS = {
  dueDateFrom: '',
  dueDateTo: '',
  kanbanColumnId: '',
  priority: '',
  activityType: '',
}

const KANBAN_TASKS_REPORT_TYPES = [
  { value: 'full', label: 'Relatório Completo' },
  { value: 'by_department', label: 'Relatório por Departamento' },
  { value: 'by_user', label: 'Relatório de Usuários' },
  { value: 'custom', label: 'Relatório Personalizado' },
]

const EXPORT_FORMAT_TYPES = {
  PDF: 'pdf',
  EXCEL: 'excel',
}
const ACCEPTANCE_DRIVER_STEP_TOUR = 'acceptance-driver-step-tour'
const ACCEPTANCE_DRIVER_STEP_BUTTON = 'acceptance-driver-step-button'

const ACCEPTANCE_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + ACCEPTANCE_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório de aceites é um documento que registra formalmente a autorização ou concordância de uma pessoa em relação às políticas e termos definidos pela empresa. Ele garante rastreabilidade e transparência no processo de validação, servindo como evidência de conformidade. Além disso, pode ser utilizado como apoio em apresentações para a diretoria, em auditorias de segurança da informação ou como ferramenta de acompanhamento para gestores e líderes, reforçando a governança e o comprometimento organizacional.',
    },
  },
  {
    element: '#' + ACCEPTANCE_DRIVER_STEP_BUTTON,
    popover: {
      description:
        'Gere seu RELATÓRIO, ele fornece o conteúdo do documento, suas versões e seus aceites. Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha "Excluir versão atual e gerar uma nova"',
    },
  },
]

const INCIDENT_DRIVER_STEP_TOUR = 'incident-driver-step-tour'
const INCIDENT_DRIVER_STEP_BUTTON = 'incident-driver-step-button'

const INCIDENT_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + INCIDENT_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O Relatório de Incidentes é um recurso que reúne, em um único documento, o histórico completo de todos os incidentes ocorridos dentro da organização, permitindo uma visão consolidada e organizada dessas ocorrências. Ele possibilita a aplicação de diversos filtros — como período, origem do incidente, classificação, status, usuário responsável e etapa do processo — para facilitar a análise, identificar padrões e apoiar a tomada de decisões estratégicas relacionadas à gestão e prevenção de incidentes.',
    },
  },
  {
    element: '#' + INCIDENT_DRIVER_STEP_BUTTON,
    popover: {
      description:
        'Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha "Excluir versão atual e gerar uma nova"',
    },
  },
]

const RIPD_DRIVER_STEP_TOUR = 'ripd-driver-step-tour'
const RIPD_DRIVER_STEP_BUTTON = 'ripd-driver-step-button'

const RIPD_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + RIPD_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O Relário RIPD é exigido pela LGPD para atividades de tratamento de dados com risco aos direitos individuais. O relatório contém detalhes cruciais sobre essas atividades, controles de proteção de dados e planos de ação, e deve ser apresentado em auditorias, para diretores, lideres ou para quem deseja saber sobre os riscos da organização.',
    },
  },
  {
    element: '#' + RIPD_DRIVER_STEP_BUTTON,
    popover: {
      description:
        "Gere seu RELATÓRIO! O RIPD estabelece a gestão de riscos altos ou severos dentro de uma organização. Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha 'Excluir versão atual e gerar uma nova'",
    },
  },
]

const ROPA_DRIVER_STEP_TOUR = 'ropa-driver-step-tour'
const ROPA_DRIVER_STEP_BUTTON = 'ropa-driver-step-button'

const ROPA_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + ROPA_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório RoPA deve ser apresentado a quem deseja saber informações mais detalhadas referentes aos riscos e registros das operações de tratamento de dados pessoais mantidos pelos controladores e operadores, especialmente quando baseados no legítimo interesse.',
    },
  },
  {
    element: '#' + ROPA_DRIVER_STEP_BUTTON,
    popover: {
      description:
        "Gere seu RELATÓRIO! O RoPA detalha todas as atividades de processamento de dados pessoais de uma organização. Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha 'Excluir versão atual e gerar uma nova'",
    },
  },
]

const ACCOUNTABILITY_DRIVER_STEP_TOUR = 'accountability-driver-step-tour'
const ACCOUNTABILITY_DRIVER_STEP_BUTTON = 'accountability-driver-step-button'

const ACCOUNTABILITY_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + ACCOUNTABILITY_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório de prestação de contas é um documento que comprova a observância e o cumprimento das normas de proteção de dados pessoais e,inclusive, da eficácia dessas medidas,deve ser apresentado em auditorias, para diretores, lideres ou para quem o solicitar de acordo com a necessidade.',
    },
  },
  {
    element: '#' + ACCOUNTABILITY_DRIVER_STEP_BUTTON,
    popover: {
      description:
        'Gere seu RELATÓRIO! O relatório de declaração de prestação de contas visa demonstrar que o agente implementou medidas eficazes para garantir a conformidade com as normas de proteção de dados pessoais.',
    },
  },
]

const MANAGEMENT_DRIVER_STEP_TOUR = 'management-driver-step-tour'
const MANAGEMENT_DRIVER_STEP_BUTTON = 'management-driver-step-button'

const MANAGEMENT_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + MANAGEMENT_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório gerencial é destinado àqueles interessados nos dados relativos ao desempenho da organização dentro plataforma, os quais são apresentados por meio de gráficos. Pode ser requisitado em auditorias, por diretores, líderes ou qualquer pessoa conforme necessário.',
    },
  },
  {
    element: '#' + MANAGEMENT_DRIVER_STEP_BUTTON,
    popover: {
      description:
        "Gere seu RELATÓRIO, ele fornece uma visão geral do desempenho da organização. Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha 'Excluir versão atual e gerar uma nova'",
    },
  },
]

const CONTROL_DRIVER_STEP_TOUR = 'control-driver-step-tour'
const CONTROL_DRIVER_STEP_BUTTON = 'control-driver-step-button'

const CONTROL_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + CONTROL_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório de medidas de segurança deve ser disponibilizado para aqueles interessados nos questionários, controles e planos de ação relacionados à proteção de dados. Pode ser requisitado em auditorias, por diretores, líderes ou qualquer pessoa conforme necessário, promovendo transparência e garantindo a conformidade com as normas de segurança de dados.',
    },
  },
  {
    element: '#' + CONTROL_DRIVER_STEP_BUTTON,
    popover: {
      description:
        "Gere seu RELATÓRIO! O relatório de medidas de segurança avalia o cumprimento das regulamentações e políticas estabelecidas pela organização. Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha 'Excluir versão atual e gerar uma nova'",
    },
  },
]

const FRAGILITY_DRIVER_STEP_TOUR = 'fragility-driver-step-tour'
const FRAGILITY_DRIVER_STEP_BUTTON = 'fragility-driver-step-button'

const FRAGILITY_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + FRAGILITY_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório de ameaças deve ser apresentado a quem deseja conhecer as ameaças presentes na organização, detalhando as medidas de segurança adotadas e os locais de ocorrência. Pode ser solicitado em auditorias, por diretores, líderes ou qualquer pessoa conforme necessário, promovendo transparência e assegurando a conformidade com as normas de segurança de dados.',
    },
  },
  {
    element: '#' + FRAGILITY_DRIVER_STEP_BUTTON,
    popover: {
      description:
        "Gere seu RELATÓRIO para uma visão completa das ameaças na organização. Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha 'Excluir versão atual e gerar uma nova'",
    },
  },
]

const TRAINING_DRIVER_STEP_TOUR = 'training-driver-step-tour'
const TRAINING_DRIVER_STEP_BUTTON = 'training-driver-step-button'

const TRAINING_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + TRAINING_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório de treinamentos deve ser apresentado a quem deseja saber quais departamentos tem a maior porcentagem de colaboradores certificados com métricas por departamento e listagens dos usuários. Pode ser requisitado em auditorias, por diretores, líderes ou qualquer pessoa conforme necessário.',
    },
  },
  {
    element: '#' + TRAINING_DRIVER_STEP_BUTTON,
    popover: {
      description:
        "Gere seu RELATÓRIO para acompanhar a evolução da conscientização dos colaboradores da organização. Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha 'Excluir versão atual e gerar uma nova",
    },
  },
]

const LIA_DRIVER_STEP_TOUR = 'lia-driver-step-tour'
const LIA_DRIVER_STEP_BUTTON = 'lia-driver-step-button'

const LIA_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + LIA_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório de legítimo interesse deve ser apresentado a quem deseja saber informações mais detalhadas referentes aos riscos e registros das operações de tratamento de dados pessoais baseados no legítimo interesse.',
    },
  },
  {
    element: '#' + LIA_DRIVER_STEP_BUTTON,
    popover: {
      description:
        "Um relatório de legítimo interesse é um documento que detalha as razões pelas quais uma organização acredita que o processamento de dados pessoais é justificado com base no princípio do legítimo interesse. Após gerar o relatório, veja suas versões abaixo. As versões geradas serão registradas mensalmente. Se necessário, realize modificações, gere um novo relatório e escolha 'Excluir versão atual e gerar uma nova'.",
    },
  },
]

const CONSENT_DRIVER_STEP_TOUR = 'consent-driver-step-tour'
const CONSENT_DRIVER_STEP_BUTTON = 'consent-driver-step-button'

const CONSENT_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + CONSENT_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório de consentimento é um documento que formaliza a autorização ou o acordo de uma pessoa para participar em uma atividade, projeto ou processo.',
    },
  },
  {
    element: '#' + CONSENT_DRIVER_STEP_BUTTON,
    popover: {
      description:
        "Um relatório de consentimento é um documento que detalha os recibos gerados em atividades, projetos ou processos. É possível baixar um único recibo, todos os recibos de um único formulário, todos os recibos de uma pessoa e todos os recibos de todos os formulários. Após gerar o relatório, veja suas versões abaixo. As versões geradas serão registradas mensalmente. Se necessário, realize modificações, gere um novo relatório e escolha 'Excluir versão atual e gerar uma nova'.",
    },
  },
]

const AUDTT_DRIVER_STEP_TOUR = 'audit-driver-step-tour'
const AUDIT_DRIVER_STEP_BUTTON = 'audit-driver-step-button'

const AUDIT_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + AUDTT_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O Relatório de Auditoria oferece uma visão abrangente dos processos auditados, tanto em auditorias específicas quanto em todas as realizadas. Ele apresenta métricas sobre o total de processos auditados, destacando quais estão atualizados ou desatualizados, e identifica os responsáveis de cada setor.',
    },
  },
  {
    element: '#' + AUDIT_DRIVER_STEP_BUTTON,
    popover: {
      description:
        "Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha 'Excluir versão atual e gerar uma nova'.",
    },
  },
]

const PARTNER_DRIVER_STEP_TOUR = 'partner-driver-step-tour'
const PARTNER_DRIVER_STEP_BUTTON = 'partner-driver-step-button'

const PARTNER_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + PARTNER_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório de fornecedores é voltado para quem precisa acompanhar a conformidade das empresas com as quais compartilha dados. Ele pode ser solicitado em auditorias, por diretores, líderes ou qualquer pessoa que necessite dessas informações.',
    },
  },
  {
    element: '#' + PARTNER_DRIVER_STEP_BUTTON,
    popover: {
      description:
        'Gere seu RELATÓRIO, ele fornece uma visão geral ou individual de seus terceiros. Após gerar o relatório, veja suas versões abaixo. As versões geradas ficarão registradas mensalmente. Caso necessário realize modificações, gere um novo relatório e escolha "Excluir versão atual e gerar uma nova"',
    },
  },
]

const COOKIES_CONSENTS_DRIVER_STEP_TOUR = 'cookies-consents-driver-step-tour'
const COOKIES_CONSENTS_DRIVER_STEP_BUTTON =
  'cookies-consents-driver-step-button'

const COOKIES_CONSENTS_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + COOKIES_CONSENTS_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O relatório de cookies é essencial para garantir transparência e conformidade legal, permitindo que empresas acompanhem consentimentos, recusas e preferências dos usuários. Além de atender exigências da LGPD, fortalece a confiança do cliente e auxilia na gestão responsável dos dados coletados.',
    },
  },
  {
    element: '#' + COOKIES_CONSENTS_DRIVER_STEP_BUTTON,
    popover: {
      description:
        'Um relatório de cookies é um documento que detalha os consentimentos coletados em sites, incluindo aceites, recusas e consentimentos parciais. É possível gerar relatórios completos ou por banner específico, aplicar filtros por data ou status e acompanhar mensalmente as versões registradas. Se necessário, atualize os dados e gere uma nova versão.',
    },
  },
]

const COOKIES_TAGS_DRIVER_STEP_TOUR = 'cookies-tags-driver-step-tour'
const COOKIES_TAGS_DRIVER_STEP_BUTTON = 'cookies-tags-driver-step-button'

const COOKIES_TAGS_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + COOKIES_TAGS_DRIVER_STEP_TOUR,
    popover: {
      description:
        'O Relatório de Tags de Cookies é essencial para garantir a transparência e a conformidade legal no uso de cookies, permitindo que as empresas acompanhem as tags utilizadas em seus sites, bem como sua classificação, em atendimento às exigências da LGPD. Além de atender exigências da LGPD, fortalece a confiança do cliente e auxilia na gestão responsável dos dados coletados.',
    },
  },
  {
    element: '#' + COOKIES_TAGS_DRIVER_STEP_BUTTON,
    popover: {
      description:
        'Um relatório de cookies é um documento que detalha as tags utilizadas em sites. É possível gerar relatórios completos ou por banners específicos. Se necessário, atualize os dados e gere uma nova versão.',
    },
  },
]

const REPORTS_DRIVER_TYPE_OBJECT = {
  acceptance: {
    object: ACCEPTANCE_DRIVER_STEPS_OBJECT,
    tour: ACCEPTANCE_DRIVER_STEP_TOUR,
    button: ACCEPTANCE_DRIVER_STEP_BUTTON,
  },
  ripd: {
    object: RIPD_DRIVER_STEPS_OBJECT,
    tour: RIPD_DRIVER_STEP_TOUR,
    button: RIPD_DRIVER_STEP_BUTTON,
  },
  ropa: {
    object: ROPA_DRIVER_STEPS_OBJECT,
    tour: ROPA_DRIVER_STEP_TOUR,
    button: ROPA_DRIVER_STEP_BUTTON,
  },
  accountability: {
    object: ACCOUNTABILITY_DRIVER_STEPS_OBJECT,
    tour: ACCOUNTABILITY_DRIVER_STEP_TOUR,
    button: ACCOUNTABILITY_DRIVER_STEP_BUTTON,
  },
  management: {
    object: MANAGEMENT_DRIVER_STEPS_OBJECT,
    tour: MANAGEMENT_DRIVER_STEP_TOUR,
    button: MANAGEMENT_DRIVER_STEP_BUTTON,
  },
  control: {
    object: CONTROL_DRIVER_STEPS_OBJECT,
    tour: CONTROL_DRIVER_STEP_TOUR,
    button: CONTROL_DRIVER_STEP_BUTTON,
  },
  fragility: {
    object: FRAGILITY_DRIVER_STEPS_OBJECT,
    tour: FRAGILITY_DRIVER_STEP_TOUR,
    button: FRAGILITY_DRIVER_STEP_BUTTON,
  },
  training: {
    object: TRAINING_DRIVER_STEPS_OBJECT,
    tour: TRAINING_DRIVER_STEP_TOUR,
    button: TRAINING_DRIVER_STEP_BUTTON,
  },
  lia: {
    object: LIA_DRIVER_STEPS_OBJECT,
    tour: LIA_DRIVER_STEP_TOUR,
    button: LIA_DRIVER_STEP_BUTTON,
  },
  consent: {
    object: CONSENT_DRIVER_STEPS_OBJECT,
    tour: CONSENT_DRIVER_STEP_TOUR,
    button: CONSENT_DRIVER_STEP_BUTTON,
  },
  audit: {
    object: AUDIT_DRIVER_STEPS_OBJECT,
    tour: AUDTT_DRIVER_STEP_TOUR,
    button: AUDIT_DRIVER_STEP_BUTTON,
  },
  partner: {
    object: PARTNER_DRIVER_STEPS_OBJECT,
    tour: PARTNER_DRIVER_STEP_TOUR,
    button: PARTNER_DRIVER_STEP_BUTTON,
  },
  cookiesConsents: {
    object: COOKIES_CONSENTS_DRIVER_STEPS_OBJECT,
    tour: COOKIES_CONSENTS_DRIVER_STEP_TOUR,
    button: COOKIES_CONSENTS_DRIVER_STEP_BUTTON,
  },
  cookiesTags: {
    object: COOKIES_TAGS_DRIVER_STEPS_OBJECT,
    tour: COOKIES_TAGS_DRIVER_STEP_TOUR,
    button: COOKIES_TAGS_DRIVER_STEP_BUTTON,
  },
  incident: {
    object: INCIDENT_DRIVER_STEPS_OBJECT,
    tour: INCIDENT_DRIVER_STEP_TOUR,
    button: INCIDENT_DRIVER_STEP_BUTTON,
  },
}

export default {
  CHARACTER_LIMIT,
  DESCRIPTION,
  EXPORT_FORMAT_TYPES,
  JUSTIFICATION_LABEL,
  JUSTIFICATION,
  KIND,
  KANBAN_TASKS_ACTIVITY_TYPES,
  KANBAN_TASKS_EMPTY_FILTERS,
  KANBAN_TASKS_FILTER_ALL,
  KANBAN_TASKS_PRIORITIES,
  KANBAN_TASKS_REPORT_TYPES,
  REPORT_CONSENT_LABELS,
  REPORT_TYPES,
  REPORTS_DRIVER_TYPE_OBJECT,
  RISK,
  TYPES_CONSENTS,
}
